import * as React from "react";
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import SummarizeIcon from '@mui/icons-material/Summarize';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import { Link } from 'react-router-dom';
import {logger} from '../../utils';
import { makeStyles } from "@mui/styles";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

export default function InvoiceReport({data}) {
    const [open, setOpen] = React.useState(false);
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [day, setDay] = React.useState(new Date());
    const [POChoices, setPOChoices] = React.useState([]);
    const [invoiceChoices, setInvoiceChoices] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [Discount, setDiscount] = React.useState({})
    const [PO, setPO] = React.useState(1);
    const [invoice, setInvoice] = React.useState(0);
    const [list, setList] = React.useState([])
    const [overTime, setsOverTime] = React.useState([])
 

    const handleClickOpen = () => {
        handleGenerate();
        setOpen(true);
    };
   

    const handleClose = () => {
        setOpen(false);
    };

    const GetOverTime = async (sow, IsBilled, DiscountID, Date) => {
        await fetch(`/api/SOW/OverTime/${sow}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setsOverTime(json))

        if (IsBilled == 1) {
            fetch(`/api/DiscountID/${DiscountID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setDiscount(json));
        } else {
            fetch(`/api/Discount_Active/${Date}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setDiscount(json));
        }
    };

    const handleGenerate = () => {
        fetch(`/api/BillingInvoice/${data.POID}/${data.ID}`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(json => {
                setDataSet(json)
                GetOverTime(json[0].SOWID, json[0].IsBilled, json[0].DiscountID, json[0].EndDate)
            })
        //`/api/InvoiceBreakdown/:${req.params.InvoiceID}`
        fetch(`/api/InvoiceBreakdown/${data.ID}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
                logger("get invoices", json);
                setList(json)
            })
    };

    const getTotal = () => {
        let total = 0
        list.map((item, index) => {
            const byteArray = new Uint8Array(item.Rate.data);
            const textDecoder = new TextDecoder();
            const res = textDecoder.decode(byteArray);
            const r = parseFloat(res).toFixed(2);
            total += calculateRate(r, item.FlagType) * item.Hours
        })
        return total.toFixed(2)
    };

    const calculateRate = (rate, flagType) => {
        if (overTime.length) {
            if (flagType === 'OT') {
                return rate * overTime[0].OverTimeWeek;
            } else if (flagType === 'WND') {
                return rate * overTime[0].OverTimeWeekEnd;
            } else if (flagType === 'HOL') {
                return rate * overTime[0].OverTimeHoliday;
            } else {
                return rate;
            }
        }
    };

    const applyDiscount = (price) => {
        var getPrice = Discount.Discount / 100;

        var totalValue = price - (price * getPrice)
        logger(totalValue.toFixed(2));
        return totalValue.toFixed(2);
    }

    React.useEffect(() => {})
    

    return (
        <div>
            <Tooltip title="Invoice Report" placement="top-end">
                <IconButton variant="contained" disabled={!data.IsBilled} onClick={handleClickOpen}>
                    <SummarizeIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} maxWidth="1400px" scroll="paper" overflow-y="hidden">
                <DialogContent >
                    {dataSet.map((value, index) => {
                        return (
                            <Box key={index}>
                                <DialogTitle>{moment(value.StartDate).format('MMMM')}</DialogTitle>
                                <p>{moment(value.StartDate).format('MM/DD/YYYY')}-{moment(value.EndDate).format('MM/DD/YYYY')}</p>
                                <p>INVOICE REQUST_{value.PoNumber}_{moment(value.StartDate).format('MMMM')}</p>
                                <p><b>PO#:</b>{value.PoNumber}<br />
                                    <b>Name:</b>{value.Name}</p>
                                <div> <b>RAW total:</b>${getTotal()} <b>Discount:</b>{Discount.Discount}%  <b>Discounted total:</b>${applyDiscount(getTotal())} </div>
                                <p><b>Sold To:</b>{value.SoldTo}<br />
                                    <b>Ship To:</b>{value.ShipTo}</p>

                                <p><b>CostCenter:</b>{value.NameCostCenter}<br />
                                    <b>CostCenter#:</b>{value.CostCenter}<br />
                                    <b>Invoice Amount:</b>{value.InvoiceAmount}</p>

                                <p>
                                    <b>Owner:</b>{value.Owner}<br />
                                    <b>Email:</b>{value.Email}<br />
                                    <b>Email Group:</b>{value.EmailGroup}
                                </p>
                            </Box>
                        );
                    })}
                </DialogContent>
            </Dialog>
        </div>
    );
}